/**
 * CheckFlagsSection.tsx
 * 免許確認, 支払い確認, 利用規約, 免責事項, 契約同意
 */
import React from 'react';
import { SectionProps } from '../types';
import SectionHeader from '../shared/SectionHeader';

interface CheckFlagsSectionProps extends SectionProps {
  onPaymentCheckChange?: (checked: boolean) => void;
}

const FLAGS = [
  { id: 'license', label: '免許確認' },
  { id: 'payment', label: '支払い確認' },
  { id: 'terms_and_conditions', label: '利用規約' },
  { id: 'disclaimer', label: '免責事項' },
  { id: 'agreement', label: '契約同意' },
] as const;

export default function CheckFlagsSection({
  data,
  onChange,
  disabled,
  onPaymentCheckChange,
}: CheckFlagsSectionProps) {
  const handleToggle = (id: string) => {
    if (disabled) return;
    const newVal = !data[id];
    if (id === 'payment' && onPaymentCheckChange) {
      onPaymentCheckChange(newVal);
      return;
    }
    onChange?.({ [id]: newVal });
  };

  const btnStyle = (active: boolean) => ({
    padding: '2px 8px',
    fontSize: '0.75rem',
    fontWeight: active ? 600 : 400,
    border: active ? '1px solid #3b82f6' : '1px solid #cbd5e1',
    borderRadius: 4,
    cursor: disabled ? 'default' : 'pointer',
    background: active ? '#3b82f6' : '#e2e8f0',
    color: active ? '#ffffff' : '#64748b',
    boxShadow: 'none' as const,
    transition: 'all 0.15s',
  });

  return (
    <>
      <SectionHeader title="確認・同意状況" />
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, padding: '8px 4px' }}>
        {FLAGS.map((flag) => (
          <button
            key={flag.id}
            type="button"
            style={btnStyle(!!data[flag.id])}
            onClick={() => handleToggle(flag.id)}
          >
            {flag.label}
          </button>
        ))}
      </div>
    </>
  );
}
